import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state'
import { usePlayerSearchActions } from './use-player-search-actions.hook'

export const usePlayerSearchFilters = () => {
  const { getPlayersSearch, setPlayerPagination } = usePlayerSearchActions()

  const { paginationSearch } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const handleChangePage = (newPage: number) => {
    setPlayerPagination({ ...paginationSearch, page: newPage })
    getPlayersSearch({ limit: paginationSearch.limit, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (
      Math.ceil(paginationSearch.total / newLimit) <
      (paginationSearch.page || 1)
    ) {
      setPlayerPagination({
        ...paginationSearch,
        limit: newLimit,
        page: 1,
      })
      getPlayersSearch({ limit: newLimit, page: 1 })
    } else {
      setPlayerPagination({ ...paginationSearch, limit: newLimit })
      getPlayersSearch({ page: paginationSearch.page, limit: newLimit })
    }
  }

  return {
    handleChangePage,
    handleChangeLimit,
  }
}
